import { useMemo } from 'react'
import useSwr from 'swr'

import { subcatImportPromiseDeprecated } from 'experiments/pen-2866_v1_alternative_categories/subcatImportPromise'
import type { SubcatsFixture } from 'experiments/pen-2866_v1_alternative_categories/types'

export type AllSubcats = Awaited<
  ReturnType<typeof subcatImportPromiseDeprecated>
>['default']

const useSubcats = () =>
  useSwr('subcategories-fixture', () =>
    subcatImportPromiseDeprecated().then((m) => m.default as SubcatsFixture),
  )

/** @deprecated */
export const useAllSubcategoriesDeprecated = () => {
  const { data, error: subcatsError } = useSubcats()
  return { subcats: data, subcatsError }
}

/** @deprecated */
export const useSubcategoriesDeprecated = ({ slug }: { slug: string }) => {
  const { data, error: subcatsError } = useSubcats()

  const subcats = useMemo(() => {
    const subcatsData = data?.[slug as keyof AllSubcats]
    return subcatsData?.subcategories?.sort((sc1, sc2) =>
      sc1.name < sc2.name ? -1 : 1,
    )
  }, [data, slug])

  return { subcats, subcatsError }
}
